import RadioGroup from '../RadioGroup'
import HookFormHoc from './HookFormHoc'

export default HookFormHoc(RadioGroup)
